import { useSelector } from "react-redux";
import get from "lodash/get";
import { pencilGrayIcon, userDeleteIcon } from "../../assets/icons";
import { profilePic } from "../../assets/images";
import { getFormattedDate } from "../../helpers";
import truncate from "lodash/truncate";
import { selectUser } from "../UserProfile";

const UserCard = ({ user, handleManageUser, handleOnDeleteClick }) => {
  const {
    userApplicationAssociations: applications,
    name,
    profilePicUrl,
    createdAt,
  } = user;
  const userAdmin = useSelector(selectUser);

  return (
    <div className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3 bg-gray-800 rounded-lg overflow-hidden flex justify-between flex-col hover:shadow-lg hover:bg-gray-700/75 hover:scale-[1.02] hover:duration-100">
      <div className="p-8 px-4">
        <div className="mb-6">
          <img
            src={profilePicUrl || profilePic}
            className="mx-auto rounded-full"
            width="126"
            alt="profile-pic"
          />
        </div>
        <div className="text-center">
          <h6 className="text-sm font-medium text-gray-50 mb-2" title={name}>
            {truncate(name, { length: 20 })}
          </h6>
          <span className="text-sm text-gray-500 block mb-3">
            {getFormattedDate(createdAt)}
          </span>
          <div className="bg-emerald-100 rounded-xl h-5 px-3 inline-flex items-center">
            <span className="text-emerald-800 text-xs font-medium inline-block">
              {get(applications, "length") || 0} applications
            </span>
          </div>
        </div>
      </div>
      <div className="flex divide-x divide-gray-700 border-t border-gray-700">
        {user.id !== userAdmin.id &&
        <button
          className="flex-1 flex items-center justify-center px-4 py-4 hover:bg-gray-700/20"
          onClick={() => handleManageUser(user)}
        >
          <div className="icon mr-3 shrink-0">
            <img src={pencilGrayIcon} width="20" alt="manage" />
          </div>
          <span className="text-sm font-medium text-gray-400">Manage</span>
        </button>
        }
        <button
          className="flex-1 flex items-center justify-center px-4 py-4 hover:bg-gray-700/20"
          onClick={handleOnDeleteClick}
        >
          <div className="icon mr-3 v">
            <img src={userDeleteIcon} width="20" alt="delete" />
          </div>
          <span className="text-sm font-medium text-gray-400">Delete</span>
        </button>
      </div>
    </div>
  );
};
export default UserCard;
